import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { PublishRequestEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class PublishRequestSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    requestAccepted$() {
        return this.socketService.receiveMessageObserver(PublishRequestEvents.REQUEST_ACCEPTED);
    }

    requestRejected$() {
        return this.socketService.receiveMessageObserver(PublishRequestEvents.REQUEST_REJECTED);
    }

    publishRequestCreated$() {
        return this.socketService.receiveMessageObserver(PublishRequestEvents.PUBLISH_CREATED);
    }

    publishRequestAccepted$() {
        return this.socketService.receiveMessageObserver(PublishRequestEvents.PUBLISH_APPROVED);
    }

    publishRequestRejected$() {
        return this.socketService.receiveMessageObserver(PublishRequestEvents.PUBLISH_REJECTED);
    }
}
